import { ArrowRight, Star, ShieldCheck } from "lucide-react";
import { COMPANY, IMAGES } from "../../data/site";

export const Hero = () => {
    return (
        <section
            data-testid="hero-section"
            className="relative min-h-[92vh] flex items-center pt-28 pb-20 overflow-hidden"
        >
            {/* Background warm wash */}
            <div className="absolute inset-0 -z-10">
                <div className="absolute inset-0 bg-bone" />
                <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-copper/10 blur-3xl" />
                <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-moss/10 blur-3xl" />
            </div>

            <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center w-full">
                {/* Text */}
                <div className="lg:col-span-7">
                    <div
                        data-testid="hero-eyebrow"
                        className="inline-flex items-center gap-2 text-xs tracking-[0.22em] uppercase font-bold text-moss mb-8 reveal"
                    >
                        <span className="h-px w-10 bg-moss" />
                        Chicagoland · NW Indiana · NICOR Partner
                    </div>

                    <h1
                        data-testid="hero-headline"
                        className="font-heading text-4xl sm:text-5xl lg:text-7xl font-extrabold tracking-tight leading-[0.98] text-ink reveal"
                    >
                        Tighter homes.
                        <br />
                        <span className="text-copper">Lower bills.</span>
                        <br />
                        Real craftsmanship.
                    </h1>

                    <p
                        data-testid="hero-sub"
                        className="mt-8 text-lg md:text-xl text-muted_ink max-w-xl leading-relaxed reveal"
                    >
                        Spray foam, dense-pack cellulose, attic & crawl space systems — done right
                        by a crew with <strong className="text-ink">50 years combined</strong>{" "}
                        experience and{" "}
                        <strong className="text-ink">
                            {COMPANY.fiveStarReviews}+ five-star reviews
                        </strong>{" "}
                        in the last 18 months.
                    </p>

                    <div className="mt-10 flex flex-col sm:flex-row gap-4 reveal">
                        <a
                            href="#quote"
                            data-testid="hero-cta-quote"
                            className="btn-lift inline-flex items-center justify-center gap-2 bg-copper text-bone font-semibold py-4 px-8 hover:bg-copper-hover"
                        >
                            Get a Free Quote
                            <ArrowRight size={18} />
                        </a>
                        <a
                            href="#services"
                            data-testid="hero-cta-services"
                            className="btn-lift inline-flex items-center justify-center gap-2 border-2 border-ink text-ink font-semibold py-4 px-8 hover:bg-ink hover:text-bone"
                        >
                            See Our Services
                        </a>
                    </div>

                    {/* Trust micro-row */}
                    <div className="mt-12 flex flex-wrap items-center gap-x-10 gap-y-5 reveal">
                        <div className="flex items-center gap-2">
                            <div className="flex">
                                {[0, 1, 2, 3, 4].map((i) => (
                                    <Star
                                        key={i}
                                        size={18}
                                        className="fill-ember text-ember"
                                        strokeWidth={1.5}
                                    />
                                ))}
                            </div>
                            <span className="text-sm font-semibold">
                                {COMPANY.fiveStarReviews}+ 5-star reviews
                            </span>
                        </div>
                        <div className="flex items-center gap-2 text-sm font-semibold">
                            <ShieldCheck
                                size={18}
                                strokeWidth={1.5}
                                className="text-moss"
                            />
                            NICOR Rebate Partner
                        </div>
                        <div className="flex items-center gap-2 text-sm font-semibold">
                            <ShieldCheck
                                size={18}
                                strokeWidth={1.5}
                                className="text-copper"
                            />
                            BPI Certified
                        </div>
                        <div className="text-sm font-semibold">
                            Insured · Licensed · IL & IN
                        </div>
                    </div>
                </div>

                {/* Image */}
                <div className="lg:col-span-5 hidden md:block reveal">
                    <div className="relative aspect-[4/5] w-full">
                        <img
                            src={IMAGES.hero}
                            alt="Modern suburban home — energy efficient envelope"
                            className="absolute inset-0 w-full h-full object-cover"
                            data-testid="hero-image"
                        />
                        {/* Floating credential card */}
                        <div className="absolute -bottom-8 -left-8 bg-moss text-bone p-6 max-w-[260px] shadow-xl">
                            <div className="text-xs uppercase tracking-[0.2em] opacity-80">
                                Founder Track Record
                            </div>
                            <div className="font-heading text-2xl font-bold mt-2 leading-tight">
                                1 → 13 trucks.
                                <br />50+ 5-star reviews.
                            </div>
                            <div className="text-xs mt-3 opacity-80">
                                7 yrs at Green Attic · Built Titanium Insulation
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
